import React, { useState } from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import AuthService from "../../Components/auth/AuthService";
import moment from "moment";
import { DATE_FORMAT, vehicleTypes, DEFAULT_DATE_FORMAT, EXPIRATION_TIME } from "../../Components/common/constants";
import _ from "lodash";
import {
  useLoadingDispatch,
  showLoading,
  hideLoading,
} from "../../context/loadingContext";
import { EditFilled, PlusCircleFilled, SearchOutlined } from "@ant-design/icons";
import { Space, Table, Tag, Button as AntButton, DatePicker as AntDate } from "antd/es";
import dayjs from "dayjs";
import { showMessage } from "../../Components/Utils/message";

const useStyles = makeStyles((theme) => ({
  antAddIcon: {
    "& .anticon-plus-circle:hover": {
      color: "#4096ff !important"
    }
  },
}));

const Auth = new AuthService();
const { RangePicker } = AntDate;

const FILTERS_KEY = "RoastersFilters";

export default function RoasterList() {
  const classes = useStyles();
  const navigate = useNavigate();
  var layoutDispatch = useLoadingDispatch();

  const [roasters, setRoasters] = React.useState([]);
  const [dateRange, setDateRange] = React.useState(null);

  const updateFilters = (newValues) => {
    const existingFiltersString = localStorage.getItem(FILTERS_KEY);
    const existingFilters = existingFiltersString ? JSON.parse(existingFiltersString) : {};
    Object.assign(existingFilters, newValues);
    existingFilters.timestamp = new Date().getTime();
    localStorage.setItem(FILTERS_KEY, JSON.stringify(existingFilters));
  };

  const getFiltersOrDefault = () => {
    const existingFiltersString = localStorage.getItem(FILTERS_KEY);
    const existingFilters = existingFiltersString ? JSON.parse(existingFiltersString) : {};
    const currentTime = new Date().getTime();

    if (existingFilters.timestamp && currentTime - existingFilters.timestamp < EXPIRATION_TIME) {
      return existingFilters;
    } else {
      localStorage.removeItem(FILTERS_KEY);
      return {};
    }
  };


  const roasterColumns = [
    {
      title: 'Date',
      dataIndex: 'roaster_date',
      key: 'roaster_date',
      width: 135,
      render: (text) => {
        return text && dayjs(text).format(DATE_FORMAT);
      },
    },
    {
      title: 'Vehicles',
      width: '500px',
      render(record) {
        return (
          record?.vehicle_roasters.map((vehicle, index) => (
            <Space>
              <Tag style={{ margin: '4px' }} color="blue" key={index}>
                {vehicle?.registration_number}
              </Tag>
            </Space>
          ))
        );
      }
    },
    {
      title: 'Drivers',
      width: '500px',
      render(record) {
        return (
          record?.driver_roasters.map((vehicle, index) => (
            <Tag style={{ margin: '4px' }} color={"geekblue"} key={index}>
              {vehicle?.driver_name}
            </Tag>
          ))
        );
      }
    },
    {
      title: 'Helpers',
      width: '300px',
      render(record) {
        return (
          record?.helper_roasters.map((vehicle, index) => (
            <Tag style={{ margin: '4px' }} key={index}>
              {vehicle?.helper_name}
            </Tag>
          ))
        );
      }
    },
    {
      title: 'Action',
      key: 'action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div >
            <EditFilled onClick={() => handleRowClick(record.id)} style={{ fontSize: '25px', cursor: "pointer", color: "#006cb8" }} />
          </div>
        );
      },
    },
  ];

  React.useEffect(() => {
    const initialState = getFiltersOrDefault();
    let startD, endD;

    if (Object.keys(initialState).length > 0 && initialState.hasOwnProperty('dateRange')) {
      if (initialState.dateRange && initialState.dateRange[0]) {
        startD = new Date(initialState.dateRange[0]);
        endD = new Date(initialState.dateRange[1]);
        setDateRange([dayjs(startD), dayjs(endD)]);
      } else {
        setDateRange(null);
      }
    } else {
      let date = new Date();
      startD = new Date(date.getFullYear(), date.getMonth(), 1);
      endD = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      setDateRange([dayjs(startD), dayjs(endD)]);

      updateFilters({
        dateRange: [dayjs(startD).format("YYYY-MM-DD"), dayjs(endD).format("YYYY-MM-DD")]
      });
    }

    showLoading(layoutDispatch);
    let searchParams = {};
    if (startD && endD) {
      searchParams = {
        start_date: moment(startD).format("YYYY-MM-DD"),
        end_date: moment(endD).format("YYYY-MM-DD"),
      };
    }

    Auth.post(`/roaster/roasters`, searchParams)
      .then((res) => {
        hideLoading(layoutDispatch);
        if (res.ack) {
          let roasters1 = res.roasters;

          let roasters2 = [];
          roasters1.map((roaster) => {
            let check = roasters2.filter(
              (r) => r.roaster_date == roaster.roaster_date
            );
            if (check.length > 0) {
              if (roaster.type == 1) {
                // vehicle
                let vehicle_type = _.find(vehicleTypes, function (o) {
                  return o.id == roaster.record_type;
                });
                check[0].vehicle_roasters.push({
                  vehicle_id: roaster.object_id,
                  registration_number:
                    roaster.object_title + " (" + vehicle_type.title + ")",
                });
              } else if (roaster.type == 2) {
                // driver

                check[0].driver_roasters.push({
                  driver_id: roaster.object_id,
                  driver_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              } else if (roaster.type == 3) {
                // helper
                check[0].helper_roasters.push({
                  helper_id: roaster.object_id,
                  helper_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              }
            } else {
              let roasterObj = {};
              roasterObj.id = roaster.id;
              roasterObj.roaster_date = roaster.roaster_date;
              roasterObj.vehicle_roasters = [];
              roasterObj.driver_roasters = [];
              roasterObj.helper_roasters = [];

              if (roaster.type == 1) {
                // vehicle
                let vehicle_type = _.find(vehicleTypes, function (o) {
                  return o.id == roaster.record_type;
                });
                roasterObj.vehicle_roasters.push({
                  vehicle_id: roaster.object_id,
                  registration_number:
                    roaster.object_title + " (" + vehicle_type.title + ")",
                });
              } else if (roaster.type == 2) {
                // driver
                roasterObj.driver_roasters.push({
                  driver_id: roaster.object_id,
                  driver_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              } else if (roaster.type == 3) {
                // helper
                roasterObj.helper_roasters.push({
                  helper_id: roaster.object_id,
                  helper_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              }

              roasters2.push(roasterObj);
            }
          });
          console.log(roasters2);
          console.log(roasters2.length);
          setRoasters(roasters2);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleRowClick = (id) => {
    navigate(`/rosters/${id}`)
  };

  const handleSearch = () => {
    setRoasters([]);
    showLoading(layoutDispatch);
    let searchParams = {};
    if (dateRange && dateRange[0]) {
      searchParams = {
        start_date: moment(dateRange[0].toDate()).format("YYYY-MM-DD"),
        end_date: moment(dateRange[1].toDate()).format("YYYY-MM-DD"),
      };
    }
    Auth.post(`/roaster/roasters`, searchParams)
      .then((res) => {
        hideLoading(layoutDispatch);
        if (res.ack) {
          let roasters1 = res.roasters;

          let roasters2 = [];
          roasters1.map((roaster) => {
            let check = roasters2.filter(
              (r) => r.roaster_date == roaster.roaster_date
            );
            if (check.length > 0) {
              if (roaster.type == 1) {
                // vehicle
                let vehicle_type = _.find(vehicleTypes, function (o) {
                  return o.id == roaster.record_type;
                });
                check[0].vehicle_roasters.push({
                  vehicle_id: roaster.object_id,
                  registration_number:
                    roaster.object_title + " (" + vehicle_type.title + ")",
                });
              } else if (roaster.type == 2) {
                // driver
                check[0].driver_roasters.push({
                  driver_id: roaster.object_id,
                  driver_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              } else if (roaster.type == 3) {
                // helper
                check[0].helper_roasters.push({
                  helper_id: roaster.object_id,
                  helper_name:
                    roaster.object_title +
                    " (" +
                    (Number(roaster.record_type) > 0 ? "F" : "E") +
                    ")",
                });
              }
            } else {
              let roasterObj = {};
              roasterObj.id = roaster.id;
              roasterObj.roaster_date = roaster.roaster_date;
              roasterObj.vehicle_roasters = [];
              roasterObj.driver_roasters = [];
              roasterObj.helper_roasters = [];

              if (roaster.type == 1) {
                // vehicle
                let vehicle_type = _.find(vehicleTypes, function (o) {
                  return o.id == roaster.record_type;
                });
                roasterObj.vehicle_roasters.push({
                  vehicle_id: roaster.object_id,
                  registration_number:
                    roaster.object_title + " (" + vehicle_type.title + ")",
                });
              } else if (roaster.type == 2) {
                // driver
                roasterObj.driver_roasters.push({
                  driver_id: roaster.object_id,
                  driver_name: roaster.object_title,
                });
              } else if (roaster.type == 3) {
                // helper
                roasterObj.helper_roasters.push({
                  helper_id: roaster.object_id,
                  helper_name: roaster.object_title,
                });
              }

              roasters2.push(roasterObj);
            }
          });
          console.log(roasters2);
          console.log(roasters2.length);
          setRoasters(roasters2);
        } else {
          showMessage('error', res?.message);

        }
      })
      .catch((err) => {
        console.log(err);
        showMessage('error', 'something went wrong');

      });
  };

  return (
    <div>
      <h2 style={{ marginBottom: '10px', marginTop: 0 }}>Rosters</h2>
      <Grid container>
        <Grid item xs={12} sm={6} md={6} lg={4} xl={2}>
          <label htmlFor="pcnDate">Date:</label>
          <RangePicker
            format={DATE_FORMAT}
            style={{ width: '100%' }}
            size="large"
            value={dateRange}
            onChange={(dates) => {
              setDateRange(dates);
              updateFilters({
                dateRange: dates ? [dates[0].format("YYYY-MM-DD"), dates[1].format("YYYY-MM-DD")] : null,
              });
            }}
            allowClear={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={1}>
          <AntButton
            type="primary"
            size="large"
            onClick={handleSearch}
            style={{ marginLeft: '5px', marginTop: "22px" }}
            icon={<SearchOutlined />}
          >
            Search
          </AntButton>

        </Grid>
      </Grid>
      <div className={classes.antAddIcon}>
        <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF", float: 'right', marginBottom: '10px' }} onClick={() => navigate("/rosters/new")} />
      </div>
      <Table
        dataSource={roasters}
        // style={{ overflowX: "auto" }}
        scroll={{ x: 'max-content' }}
        columns={roasterColumns}
        pagination={false}
        bordered
        footer={() => `List of Roasters - Total Records: ${roasters.length === 0 ? "0" : roasters.length}`}
      />
    </div>
  );
}
